export const ALL = "ALL";
export const FP = "FP";
export const FN = "FN";
// Z-score for 95% confidence interval
export const Z_SCORE = 1.96;